import { render, staticRenderFns } from "./view-who.vue?vue&type=template&id=44c0bba3&scoped=true&"
import script from "./view-who.vue?vue&type=script&lang=js&"
export * from "./view-who.vue?vue&type=script&lang=js&"
import style0 from "./view-who.vue?vue&type=style&index=0&id=44c0bba3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c0bba3",
  null
  
)

export default component.exports